// 获取新闻列表
import { queryProvince,queryCity,uploadAction,downloadAction,rlSelectList,getAttachmentCode,saveExam,deleteUserByStatusExam,userListExam,examInfo,updateExam } from "@/request/exam"

const exam = {
    actions: {
      async QueryProvince(commit: any, data: any) {
        return await queryProvince(data);
      },
      async QueryCity(commit: any, data: any) {
        return await queryCity(data);
      },
      async RlSelectList(commit: any, data: any) {
        return await rlSelectList(data);
      },
      async SaveExam(commit: any, data: any) {
        return await saveExam(data);
      },
      async GetAttachmentCode(commit: any, data: any) {
        return await getAttachmentCode(data);
      },
      async UploadFileAction(commit: any,data: any) {
        return await uploadAction('/attachment/upload',data,300000);
      },
      async DownloadAction(commit: any,data: any) {
        return await downloadAction(data);
      },
      async DeleteUserByStatusExam(commit: any,data: any) {
        return await deleteUserByStatusExam(data);
      },
      async UserListExam(commit: any,data: any) {
        return await userListExam(data);
      },
      async ExamInfo(commit: any,data: any) {
        return await examInfo(data);
      },
      async UpdateExam(commit: any,data: any) {
        return await updateExam(data);
      },
    }
  };
  export default exam;